<template lang="pug">
transition(
  :css="false"
  @before-enter="beforeEnter"
  @enter="enter"
  @leave="leave"
)
  slot
</template>

<script>
import gsap from 'gsap';
import useSuspend from '../lib/useSuspend';

export default {
  props: {
    delay: { type: Number, default: 0 },
    duration: { type: Number, default: 0.5 },
    /**
     * Automatically scroll to the element after it appears, if necessary.
     */
    scroll: { type: Boolean, default: false },
    dimension: { type: String, default: 'height' }
  },
  setup() {
    const suspend = useSuspend();
    return { suspend };
  },
  methods: {
    beforeEnter(el) {
      gsap.set(el, { [this.dimension]: 0, overflow: 'hidden', opacity: 0 });
    },
    enter(el, done) {
      const duration = this.suspend.reducedMotion ? 0 : this.duration;
      const delay = this.suspend.reducedMotion ? 0 : this.delay;

      gsap
        .timeline()
        .to(
          el,
          {
            [this.dimension]: 'auto',
            duration: duration * 0.5,
            ease: 'power2',
            clearProps: 'overflow'
          },
          delay
        )
        .to(
          el,
          {
            opacity: 1,
            duration,
            ease: 'linear',
            onComplete: () => {
              if (this.scroll && !this.suspend.reducedMotion) {
                const { top, height } = el.getBoundingClientRect();

                if (
                  // it could fit
                  height < window.innerHeight &&
                  // but it doesnt
                  top + height > window.innerHeight &&
                  // and the top isnt already higher than where we would want it
                  top > window.innerHeight / 3
                ) {
                  gsap.to(el.closest('.scroller'), {
                    scrollTo: { y: el, offsetY: window.innerHeight / 3 },
                    duration: 1,
                    overwrite: true
                  });
                }
              }

              done();
            }
          },
          delay
        );
    },
    leave(el, done) {
      const duration = this.suspend.reducedMotion ? 0 : 0.2;

      gsap
        .timeline()
        .to(el, {
          opacity: 0,
          ease: 'linear',
          duration
        })
        .to(
          el,
          {
            [this.dimension]: 0,
            overflow: 'hidden',
            ease: 'power1.out',
            duration,
            onComplete: done
          },
          0
        );
    }
  }
};
</script>
